import { MemberForm } from '../../../MemberForm'
import useMutationCreateMember from '@/modules/manage-member/api/hooks/useMutateCreateMember'
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'
import { FormValues } from '../../../MemberForm'
import { UseFormReturn } from 'react-hook-form'
import { handleMemberFormError } from '@/modules/manage-member/utils/handleMemberFormError'

export function CreateMemberForm() {
	const navigate = useNavigate()
	const { mutate: createMember } = useMutationCreateMember()

	const onSubmit = (values: FormValues, form: UseFormReturn<FormValues>) => {
		const submitValues = {
			username: values.username,
			password: values.password,
			userGroupId: values.userGroupId,
			...(values.phone ? { phone: values.phone } : {}),
		}

		createMember(submitValues, {
			onSuccess: () => {
				toast.success('สร้างผู้ใช้งานสำเร็จ')
				navigate('/operator/manage-member')
			},
			onError: (error) => handleMemberFormError(error, form, 'create'),
		})
	}

	return <MemberForm mode="create" onSubmit={onSubmit} />
}
